import styled from 'styled-components';

// export const ApplicationFlowContainer = styled.div`
//   padding-top: 64px;

//   @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
//     padding-top: 56px;
//   }

//   @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
//     padding-top: 56px;
//   }
// `;

export const ApplicationFlowWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  transition: background 0.3s ease;
`;

export const ApplicationFlowContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 64px;
  padding: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;
